import { render, staticRenderFns } from "./InboxStructureView.vue?vue&type=template&id=338d6d02"
import script from "./InboxStructureView.vue?vue&type=script&lang=js"
export * from "./InboxStructureView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports